import "./TextMarquee.css";
import React, { useEffect, useMemo, useRef, useState } from "react";

const TextMarquee = ({ items }) => {
  const wrapperRef = useRef(null);
  const textRef = useRef(null);
  const [styleVars, setStyleVars] = useState({});

  const list = useMemo(() => {
    if (Array.isArray(items)) {
      return items.map((s) => String(s).trim()).filter(Boolean);
    }
    if (typeof items === "string" && items.includes(",")) {
      return items.split(",").map((s) => s.trim()).filter(Boolean);
    }
    if (typeof items === "string") {
      return [items.trim()].filter(Boolean);
    }
    return [];
  }, [items]);

  const content = useMemo(() => {
    if (list.length === 0) return "";
    return list.join("      •     ");
  }, [list]);

  useEffect(() => {
    if (!wrapperRef.current || !textRef.current || !content) return;

    const updateMarquee = () => {
      const wrapperWidth = wrapperRef.current.offsetWidth;
      const textWidth = textRef.current.scrollWidth;

      const moveLeft = Math.max(textWidth, 0);
      const resetRight = Math.max(wrapperWidth, 0);

      // responsive speed
      const totalDistance = moveLeft + resetRight;
      const duration = Math.max(10, totalDistance / 45); // slower/faster control

      setStyleVars({
        "--move-left": `${moveLeft}px`,
        "--reset-right": `${resetRight}px`,
        "--duration": `${duration}s`,
      });
    };

    updateMarquee();

    const resizeObserver = new ResizeObserver(updateMarquee);
    resizeObserver.observe(wrapperRef.current);
    resizeObserver.observe(textRef.current);

    window.addEventListener("resize", updateMarquee);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateMarquee);
    };
  }, [content]);

  if (!content) return null;

  return (
    <div
      ref={wrapperRef}
      className="marquee-wrapper"
      role="status"
      aria-live="polite"
    >
      <div className="marquee">
        <span
          ref={textRef}
          className="marquee-text"
          style={styleVars}
          title={content}
        >
          {content}
        </span>
      </div>
    </div>
  );
};

export { TextMarquee };